import { useParams } from 'react-router-dom';
import { Form, FormProps } from 'components';
import { useCallback, useEffect } from 'react';
import { getUpdatedPayload } from 'utils/helpers';
import { useSupplierBankInformationUpdateMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { IBankInformationEditeModal } from './index';

interface BankInformationFieldType {
  id: string;
  name: string;
  accountName: string;
  accountNumber: string;
  swift: string;
  iban: string;
}

export const useBankInformationEditeModal = (props: IBankInformationEditeModal) => {
  const { onModalStateChange, modalState, dataToEdit } = props;
  const [form] = Form.useForm();
  const { id } = useParams() as { id: string };
  const { handleError, handleSuccess } = useNotificationMessages();

  const [updateBankInformation, { isLoading }] = useSupplierBankInformationUpdateMutation();

  const onCancel = useCallback(() => {
    form.resetFields();
    onModalStateChange();
  }, [form, onModalStateChange]);

  const onFinish: FormProps<BankInformationFieldType>['onFinish'] = useCallback(
    async (values: BankInformationFieldType) => {
      const payload = getUpdatedPayload(values, dataToEdit);
      payload.id = id;
      try {
        const { data, error }: Record<string, any> = await updateBankInformation(payload);
        if (data?.success) {
          handleSuccess('Bank Information was successfully updated.');
          onCancel();
        } else {
          handleError(error);
        }
      } catch (err) {
        handleError(err);
      }
    },
    [updateBankInformation, id, onCancel, dataToEdit, handleError, handleSuccess]
  );

  useEffect(() => {
    if (modalState && dataToEdit) {
      form.setFieldsValue(dataToEdit);
    }
  }, [modalState, dataToEdit, form]);

  return {
    onFinish,
    onCancel,
    form,
    isLoading,
  };
};
